module.exports = __webpack_public_path__ + "img/arrow-down-up.102c8987.svg";